import { render, staticRenderFns } from "./101.vue?vue&type=template&id=afe74b16&scoped=true&"
var script = {}
import style0 from "./101.vue?vue&type=style&index=0&id=afe74b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe74b16",
  null
  
)

export default component.exports